import { gql } from '@apollo/client'

// module removed as BE suggestion
export default gql(`
    mutation deleteSeriesSeasons($input: [ID] $assetId: ID $project: String ) {
        deleteSeriesSeasons(
            input: $input
            assetId: $assetId
            project: $project
        )
    }`
)
